import React, { useCallback, useState, useEffect } from 'react';
import cn from 'classnames';

import Button from 'Components/Button/Button';
import ToggleButton from 'Components/ToggleButton/ToggleButton';
import ReactGA from 'Shared/analytics';

const navigate = {
  PREVIOUS: 'PREV',
  NEXT: 'NEXT',
  TODAY: 'TODAY',
  DATE: 'DATE',
};

const CustomCalendarToolbar = (props) => {
  const {
    localizer: { messages },
    label,
    views,
    view,
    onChangeFilterStatus,
    toggleStatus,
  } = props;

  const [viewSelectButtonState, setViewSelectButtonState] = useState(false);
  const [currentlySelectedView, setCurrentlySelectedView] = useState(views.find((e) => e.toLowerCase() === 'week'));

  const screenWidth = document.body.clientWidth;

  useEffect(() => {
    document.body.addEventListener('click', (e) => {
      if (
        e.target.offsetParent &&
        ![...e.target.classList].includes('navigation-btn--select') &&
        ![...e.target.offsetParent.classList].includes('dropdown') &&
        viewSelectButtonState
      ) {
        setViewSelectButtonState(false);
      }
    });
  }, [viewSelectButtonState]);

  const onNavigate = useCallback(
    (action) => {
      props.onNavigate(action);
    },
    [props]
  );

  const onView = useCallback(
    (view) => {
      ReactGA.event({
        category: 'Colleagues Calendar',
        action: 'Switching between calendar views',
        label: 'Switch to' + view,
      });
      props.onView(view);
    },
    [props]
  );

  const viewNamesGroup = useCallback(
    (messages) => {
      if (views.length > 1) {
        return (
          <>
            <Button
              type="button"
              key={views[0]}
              className={cn('navigation-btn', 'navigation-btn--select')}
              onClick={() => {
                setViewSelectButtonState(!viewSelectButtonState);
                onView(currentlySelectedView);
              }}
              text={messages[currentlySelectedView]}
              hasBorder={false}
              icon={viewSelectButtonState ? 'icon-up' : 'icon-down'}
            />
            <div
              className={cn('dropdown', {
                'dropdown--hidden': !viewSelectButtonState,
                'dropdown--show': viewSelectButtonState,
              })}
            >
              {views.map((name) => {
                return (
                  <Button
                    dataTestId={name}
                    type="button"
                    key={name}
                    className={cn('navigation-btn', {
                      'navigation-btn--active': view === name,
                    })}
                    onClick={() => {
                      onView(name);
                      setCurrentlySelectedView(name);
                      setViewSelectButtonState(!viewSelectButtonState);
                    }}
                    text={messages[name]}
                    hasBorder={false}
                  />
                );
              })}
            </div>
          </>
        );
      }
    },
    [views, onView, view, viewSelectButtonState, currentlySelectedView]
  );

  return (
    <div className="toolbar vacation-calendar__toolbar">
      <div className="toolbar__btn-group">{viewNamesGroup(messages)}</div>
      {label}
      <div className="toolbar__btn-group-arrows">
        <ToggleButton
          labelName={screenWidth > 500 ? 'Only day off' : 'Day off'}
          onToggleChange={onChangeFilterStatus}
          toggleStatus={toggleStatus}
        />
        <Button
          type="button"
          text="Today"
          className={'navigation-btn navigation-btn__today'}
          onClick={() => onNavigate(navigate.TODAY)}
        />
        <Button
          type="button"
          icon="icon-left"
          dataTestId={'calendar-left'}
          className={'navigation-btn'}
          onClick={() => onNavigate(navigate.PREVIOUS)}
        />
        <Button
          type="button"
          icon="icon-right"
          dataTestId={'calendar-right'}
          className={'navigation-btn'}
          onClick={() => onNavigate(navigate.NEXT)}
        />
      </div>
    </div>
  );
};

export default CustomCalendarToolbar;
